import React, { useState } from "react";
import T from '../../components/common/T';
import api from "../../api/axiosConfig";
import Price from "../../components/common/Price";
import { toast } from "react-toastify";

export default function EditBudgetModal({ budget, onClose, onSuccess, userId }) {
  // Assuming budget object has { id, laborCostEstimate, materialCostEstimate... }
  const currentTotal = Number(budget.laborCostEstimate) + Number(budget.materialCostEstimate) + Number(budget.equipmentCostEstimate);
  
  const [newAmount, setNewAmount] = useState(currentTotal);
  const [reason, setReason] = useState("");

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (newAmount === currentTotal) return toast.info("No changes made.");
    if (reason.length < 5) return toast.error("Please provide a valid reason.");
    try {
      await api.put(`/budgets/${budget.id}`, {
        newAmount,
        reason,
        userId
      });
      toast.success("Budget updated & action logged.");
      onSuccess();
      onClose();
    } catch (err) {
      toast.error("Update failed.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-lg p-6 border-t-4 border-red-500">
        <h2 className="text-base font-bold text-gray-900 mb-1"><T>Modify Financial Baseline</T></h2>
        <p className="text-xs text-red-600 uppercase font-bold tracking-wide mb-6"><T>Restricted Action • Audit Logging Active</T></p>

        <form onSubmit={handleUpdate} className="space-y-5">
          
          <div className="grid grid-cols-2 gap-4">
            <div className="p-3 bg-gray-100 rounded">
              <span className="block text-xs text-gray-500 uppercase"><T>Current Budget</T></span>
              <span className="block text-lg font-bold text-gray-700"><Price amount={currentTotal} /></span>
            </div>
            <div className="p-3 bg-blue-50 border border-blue-200 rounded">
              <span className="block text-xs text-blue-600 uppercase font-bold"><T>New Budget</T></span>
              <input 
                type="number" 
                className="w-full bg-transparent border-b border-blue-300 focus:outline-none font-bold text-lg text-blue-900"
                value={newAmount}
                onChange={e => setNewAmount(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reason for Change <span className="text-red-500">*</span>
            </label>
            <textarea 
              className="w-full border rounded p-3 text-sm focus:ring-2 focus:ring-red-500 outline-none"
              rows="3"
              placeholder="e.g., Client approved Change Order #402..."
              value={reason}
              onChange={e => setReason(e.target.value)}
              required
            ></textarea>
            <p className="text-xs text-gray-400 mt-1"><T>This explanation will be permanently recorded in the audit log.</T></p>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"><T>Cancel</T></button>
            <button type="submit" className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 font-medium">
              Authorize Change
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}